import { TYPE } from 'vue-toastification';

export const NOTIFICATION_TYPE = {
  DEFAULT: 0, // 'У вас новое уведомление'
  EVENT_REQUEST: 1, // 'Заявка на мероприятие',
  EVENT_REJECT: 2, // 'Заявка отклонена',
  EVENT_CONFIRM: 3, // 'Заявка подтверждена',
  QUALIFYING_STAGE_ACCEPTED: 4, // 'Отборочный этап пройден',
  QUALIFYING_STAGE_REJECTED: 5, // 'Отборочный этап не пройден',
  JOINING_THE_TEAM_ACCEPTED: 6, // 'Принят в команду',
  JOINING_THE_TEAM_REJECTED: 7, // 'Не принят в команду',
  RESULT_PLACE_FOR_TEAM: 8, // not work 'Команда заняла призовое место',
  RESULT_PLACE_FOR_PARTICIPANT: 9, // 'Участник занял призовое место',
  NEXT_STAGE_FOR_TEAM_ACCEPTED: 10, // 'Команда прошла в следующий этап',
  NEXT_STAGE_FOR_PARTICIPANT_ACCEPTED: 11, // 'Участник прошел в следующий этап',
  NEXT_STAGE_FOR_TEAM_REJECTED: 12, // 'Команда не прошла в следующий этап',
  NEXT_STAGE_FOR_PARTICIPANT_REJECTED: 13, // 'Участник не прошел в следующий этап',
  EVENT_STARTS_NEXT_DAY: 14, // 'Старт мероприятия через день',
  TEAM_MUST_BE_COMPLETED: 15, // 'Необходимо срочно укомплектовать команду',
  TEAM_DISQUALIFIED: 16, // 'Команда дисквалифицирована',
  PARTICIPANT_DISQUALIFIED: 17, // 'Участник дисквалифицирован',
  FORGOT_CREATE_EVENT: 18, // 'Необходимо создать мероприятие по распоряжению вышестоящей инстанции',
  FORGOT_CREATE_EVENT_STAGES: 19, // 'Необходимо создать этапы мероприятия до его начала',
  FORGET_SUBORDINATE_ORGANIZER: 20, // 'Необходимо назначить организатора мероприятия',
  CLOSE_EVENT: 21, // 'Закрытие мероприятия',
  EXCLUDE_FROM_TEAM_BY_ORGANIZER: 22, // 'Вы исключены из команды организатором',
  ADD_TEAM_ACTIVE_MEMBER: 23, // 'Добавлен новый участник в команду',
  ADD_TEAM_REQUEST_MEMBER: 24, // 'Новая заявка в команду',
  EVENT_FOR_MODERATION: 25, // 'Новое мероприятия для модерации',
  NEED_FILL_TEAM: 26, // 'Необходимо заполнить команду',
  SUBORDINATE_REFUSE_EVENT: 27, // 'Рег. оператор/Муниципальная организация не подтвердили статус  мероприятия',
  INVITE_TO_TEAM: 28, // 'Пользователь приглашает вас вступить в команду для участия на мероприятии'
  QUALIFICATION_SEND: 29, // Новая работа отборочного этапа
  ATTACH_EXPERT_TO_EVENT: 30, // Вас добавили в качестве жюри на мероприятие
  EVENT_HAS_FINISHED_POLL: 31, // В мероприятии есть новые работы для оценки
  CONFIRM_EVENT_MODERATION: 32, // Мероприятие подтверждено после модерации
  ASSIGN_EVENT_ORGANIZER: 33, // Вашу организацию назначили организатором мероприятия
  NEW_REQUEST_TO_EVENT: 34, // Заявка на участие в мероприятии
  NEW_NEWSLETTER: 35, // Новая рассылка
  EXCHANGE_APPLY: 36, // Заявка на биржу мероприятий подтверждена
  ORGANIZER_CHANGE_USER_NOMINATION: 37, // Организатор перенес вас в другую номинацию
  TEAM_DETACH_BY_HIGH_EVENT_ORG: 38, // Удаление вышестоящим организатором участника из списка на передачу
  EVENT_EXPEL_MEMBER: 39, // Организатор исключил вас из мероприятия
  EXPERT_ADDED_TO_EVENT: 40, // Вас добавили в качестве члена жюри на мероприятие
  NEW_POLL_JOURNAL_FOR_EXPERTISE: 41, // В мероприятии есть новые работы для оценки
  EXPERT_REQUEST_ACCEPTED: 42, // Ваша заявка в качестве жюри на мероприятие принята
  EXPERT_REQUEST_REJECTED: 43, // Ваша заявка в качестве жюри на мероприятие отклонена
  NEW_EXPERT_REQUEST: 44, // Новая заявка от жюри
  EXPERT_CANCEL_EXPERT_REQUEST: 45, // Ваша заявка в качестве жюри на мероприятие отклонена другим членом жюри
  ORGANIZER_CANCEL_EXPERT_REQUEST: 46, // Ваша заявка в качестве жюри на мероприятие отклонена организатором
  MEMBER_INCORRECT_DOCUMENTS: 50, // Вы прикрепили некорректные документы к заявке
  EVENT_CHAT: 51, // Вас добавили в чат мероприятия
  EVENT_ACTIVITY_CHAT: 52, // Вас добавили в чат активности
  REGISTER_TRAINER_TEAM_MEMBER: 60, // NOT IMPLEMENTED Ваша команда допущена к участию в мероприятии
  REGISTER_TRAINER_TEAM_TRAINER: 61, // NOT IMPLEMENTED Ваша заявка на участие в мероприятии принята
  INCORRECT_DOCUMENT_TRAINER_TEAM: 62, // NOT IMPLEMENTED Организатор перевел статус вашей команды в "некорректно заполненные документы"
  REJECT_TRAINER_TEAM: 63, // NOT IMPLEMENTED Ваша команда исключена
};

export const NOTIFICATION_TYPE_ALERT = {
  [NOTIFICATION_TYPE.DEFAULT]: {
    text: 'У вас новое уведомление',
    type: TYPE.INFO,
  },
  [NOTIFICATION_TYPE.EVENT_REQUEST]: {
    text: 'Вы подали заявку на мероприятие',
    type: TYPE.ERROR,
  },
  [NOTIFICATION_TYPE.EVENT_REJECT]: {
    text: 'Заявка на мероприятие отклонена',
    type: TYPE.ERROR,
  },
  [NOTIFICATION_TYPE.EVENT_CONFIRM]: {
    text: 'Заявка на мероприятие подтверждена',
    type: TYPE.INFO,
  },
  [NOTIFICATION_TYPE.QUALIFYING_STAGE_ACCEPTED]: {
    text: 'Отборочный этап пройден',
    type: TYPE.INFO,
  },
  [NOTIFICATION_TYPE.QUALIFYING_STAGE_REJECTED]: {
    text: 'Отборочный этап не пройден',
    type: TYPE.WARNING,
  },
  [NOTIFICATION_TYPE.JOINING_THE_TEAM_ACCEPTED]: {
    text: 'Вы приняты в команду',
    type: TYPE.SUCCESS,
  },
  [NOTIFICATION_TYPE.JOINING_THE_TEAM_REJECTED]: {
    text: 'Вы не приняты в команду',
    type: TYPE.WARNING,
  },
  [NOTIFICATION_TYPE.RESULT_PLACE_FOR_TEAM]: {
    text: 'Ваша команда заняла призовое место',
    type: TYPE.INFO,
  },
  [NOTIFICATION_TYPE.RESULT_PLACE_FOR_PARTICIPANT]: {
    text: 'Вы заняли призовое место',
    type: TYPE.INFO,
  },
  [NOTIFICATION_TYPE.NEXT_STAGE_FOR_TEAM_ACCEPTED]: {
    text: 'Ваша команда прошла в следующий этап',
    type: TYPE.SUCCESS,
  },
  [NOTIFICATION_TYPE.NEXT_STAGE_FOR_PARTICIPANT_ACCEPTED]: {
    text: 'Вы прошли в следующий этап',
    type: TYPE.INFO,
  },
  [NOTIFICATION_TYPE.NEXT_STAGE_FOR_TEAM_REJECTED]: {
    text: 'Ваша команда не прошла этап',
    type: TYPE.INFO,
  },
  [NOTIFICATION_TYPE.NEXT_STAGE_FOR_PARTICIPANT_REJECTED]: {
    text: 'Вы не прошли этап',
    type: TYPE.INFO,
  },
  [NOTIFICATION_TYPE.EVENT_STARTS_NEXT_DAY]: {
    text: 'Мероприятие начнется через день',
    type: TYPE.INFO,
  },
  [NOTIFICATION_TYPE.TEAM_MUST_BE_COMPLETED]: {
    text: 'Необходимо срочно укомплектовать команду',
    type: TYPE.INFO,
  },
  [NOTIFICATION_TYPE.TEAM_DISQUALIFIED]: {
    text: 'Команда дисквалифицирована',
    type: TYPE.WARNING,
  },
  [NOTIFICATION_TYPE.PARTICIPANT_DISQUALIFIED]: {
    text: 'Вы были дисквалифицированы',
    type: TYPE.ERROR,
  },
  [NOTIFICATION_TYPE.FORGOT_CREATE_EVENT]: {
    text: 'Необходимо создать мероприятие по распоряжению вышестоящей инстанции',
    type: TYPE.WARNING,
  },
  [NOTIFICATION_TYPE.FORGOT_CREATE_EVENT_STAGES]: {
    text: 'Необходимо создать этапы мероприятия до его начала',
    type: TYPE.WARNING,
  },
  [NOTIFICATION_TYPE.FORGET_SUBORDINATE_ORGANIZER]: {
    text: 'Необходимо назначить организатора мероприятия',
    type: TYPE.ERROR,
  },
  [NOTIFICATION_TYPE.CLOSE_EVENT]: {
    text: 'Мероприятие было завершено',
    type: TYPE.INFO,
  },
  [NOTIFICATION_TYPE.EXCLUDE_FROM_TEAM_BY_ORGANIZER]: {
    text: 'Вы исключены из команды организатором',
    type: TYPE.WARNING,
  },
  [NOTIFICATION_TYPE.ADD_TEAM_ACTIVE_MEMBER]: {
    text: 'Добавлен новый участник в команду',
    type: TYPE.SUCCESS,
  },
  [NOTIFICATION_TYPE.ADD_TEAM_REQUEST_MEMBER]: {
    text: 'Новая заявка в команду',
    type: TYPE.INFO,
  },
  [NOTIFICATION_TYPE.EVENT_FOR_MODERATION]: {
    text: 'Новое мероприятия для модерации',
    type: TYPE.INFO,
  },
  [NOTIFICATION_TYPE.NEED_FILL_TEAM]: {
    text: 'Необходимо заполнить команду',
    type: TYPE.WARNING,
  },
  [NOTIFICATION_TYPE.SUBORDINATE_REFUSE_EVENT]: {
    text: 'Ваше мероприятие не прошло модерацию',
    type: TYPE.ERROR,
  },
  [NOTIFICATION_TYPE.INVITE_TO_TEAM]: {
    text: 'Вас пригласили в команду',
    type: TYPE.INFO,
  },
  [NOTIFICATION_TYPE.QUALIFICATION_SEND]: {
    text: 'Новая работа отборочного этапа',
    type: TYPE.INFO,
  },
  [NOTIFICATION_TYPE.ATTACH_EXPERT_TO_EVENT]: {
    text: 'Вас добавили в качестве жюри на мероприятие',
    type: TYPE.INFO,
  },
  [NOTIFICATION_TYPE.EVENT_HAS_FINISHED_POLL]: {
    text: 'В мероприятии есть новые работы для оценки',
    type: TYPE.INFO,
  },
  [NOTIFICATION_TYPE.CONFIRM_EVENT_MODERATION]: {
    text: 'Ваше мероприятие прошло модерацию',
    type: TYPE.SUCCESS,
  },
  [NOTIFICATION_TYPE.ASSIGN_EVENT_ORGANIZER]: {
    text: 'Вашу организацию назначили организатором мероприятия',
    type: TYPE.INFO,
  },
  [NOTIFICATION_TYPE.NEW_REQUEST_TO_EVENT]: {
    text: 'На ваше мероприятие записался новый участник',
    type: TYPE.INFO,
  },
  [NOTIFICATION_TYPE.NEW_NEWSLETTER]: {
    text: 'Новое сообщение от регионального оператора',
    type: TYPE.INFO,
  },
  [NOTIFICATION_TYPE.EXCHANGE_APPLY]: {
    text: 'Новая заявка на бирже от организатора',
    type: TYPE.INFO,
  },
  [NOTIFICATION_TYPE.ORGANIZER_CHANGE_USER_NOMINATION]: {
    text: 'Организатор перенес вас в другую номинацию',
    type: TYPE.WARNING,
  },
  [NOTIFICATION_TYPE.TEAM_DETACH_BY_HIGH_EVENT_ORG]: {
    text: 'Ваша команда была исключена вышестоящим оператором',
    type: TYPE.WARNING,
  },
  [NOTIFICATION_TYPE.EVENT_EXPEL_MEMBER]: {
    text: 'Организатор исключил вас из мероприятия',
    type: TYPE.WARNING,
  },
  [NOTIFICATION_TYPE.EXPERT_ADDED_TO_EVENT]: {
    text: 'Вас добавили в качестве члена жюри на мероприятие',
    type: TYPE.INFO,
  },
  [NOTIFICATION_TYPE.NEW_POLL_JOURNAL_FOR_EXPERTISE]: {
    text: 'В мероприятии есть новые работы для оценки',
    type: TYPE.INFO,
  },
  [NOTIFICATION_TYPE.EXPERT_REQUEST_ACCEPTED]: {
    text: 'Ваша заявка в качестве жюри на мероприятие принята',
    type: TYPE.SUCCESS,
  },
  [NOTIFICATION_TYPE.EXPERT_REQUEST_REJECTED]: {
    text: 'Ваша заявка в качестве жюри на мероприятие отклонена',
    type: TYPE.ERROR,
  },
  [NOTIFICATION_TYPE.NEW_EXPERT_REQUEST]: {
    text: 'Новая заявка от жюри',
    type: TYPE.INFO,
  },
  [NOTIFICATION_TYPE.EXPERT_CANCEL_EXPERT_REQUEST]: {
    text: 'Ваша заявка в качестве жюри на мероприятие отклонена другим членом жюри',
    type: TYPE.ERROR,
  },
  [NOTIFICATION_TYPE.ORGANIZER_CANCEL_EXPERT_REQUEST]: {
    text: 'Ваша заявка в качестве жюри на мероприятие отклонена организатором',
    type: TYPE.ERROR,
  },
  [NOTIFICATION_TYPE.MEMBER_INCORRECT_DOCUMENTS]: {
    text: 'Вы прикрепили некорректные документы к заявке',
    type: TYPE.WARNING,
  },
  [NOTIFICATION_TYPE.EVENT_CHAT]: {
    text: 'Вас добавили в чат мероприятия',
    type: TYPE.INFO,
  },
  [NOTIFICATION_TYPE.EVENT_ACTIVITY_CHAT]: {
    text: 'Вас добавили в чат активности',
    type: TYPE.INFO,
  },
};

export const NOTIFICATION_CATEGORY_TYPE = {
  ALL: null,
  EVENT: 1,
  EVENT_STAGE: 2,
  EVENT_TEAM: 3,
  EVENT_RESULTS: 4,
  QUALIFICATION: 5,
  POLL_JOURNAL: 6,
  NEWSLETTER: 7,
  EXCHANGE: 8,
};

export const NOTIFICATION_VIEW_TYPE = {
  ALL: null,
  NEW: 0,
  VIEWED: 1,
};
